export function insertPlainText(
  target: Word.Range | Word.Paragraph,
  text: string,
  location:
    | Word.InsertLocation
    | Word.InsertLocation.start
    | Word.InsertLocation.end
    | Word.InsertLocation.replace
    | Word.InsertLocation.before
    | Word.InsertLocation.after,
): Word.Range {
  const inserted = (target as Word.Range).insertText(text, location);
  inserted.font.bold = false;
  inserted.font.italic = false;
  inserted.font.underline = "None";
  inserted.font.strikeThrough = false;
  inserted.font.subscript = false;
  inserted.font.superscript = false;
  return inserted;
}
